import moment from 'moment'
import api from './api'

export const createFilters = () => ({
  userUid: '', partnerUid: '', couponNo: '', closeDateRange: [],
  dateRange: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
})

export default {
  data() {
    return { filters: createFilters(), pagination: { page: 1, size: 10 }, rows: [], total: 0, loading: false, exportLoading: false }
  },
  methods: {
    display(v) { return v === null || v === undefined || v === '' ? '-' : v },
    amount(v, precision = 4) { return v === null || v === undefined || v === '' ? '-' : Number(v).toFixed(precision) },
    time(v) { return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : '-' },
    query(paged = true) {
      const q = {}
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        q.startDate = this.filters.dateRange[0]
        q.endDate = this.filters.dateRange[1]
      }
      if (this.kind === 'position' && this.filters.closeDateRange && this.filters.closeDateRange.length === 2) {
        q.closeStartDate = this.filters.closeDateRange[0]
        q.closeEndDate = this.filters.closeDateRange[1]
      }
        ;['userUid', 'partnerUid', 'couponNo'].forEach((k) => { if (this.filters[k]) q[k] = this.filters[k] })
      if (paged) Object.assign(q, this.pagination)
      return q
    },
    valid() {
      if (this.kind === 'position' &&
          (!this.filters.dateRange || this.filters.dateRange.length === 0) &&
          (!this.filters.closeDateRange || this.filters.closeDateRange.length === 0)) return true
      const hasOpen = this.filters.dateRange && this.filters.dateRange.length === 2
      const hasClose = this.kind === 'position' && this.filters.closeDateRange && this.filters.closeDateRange.length === 2
      if (hasOpen || hasClose) return true
      this.$message.warning(this.kind === 'position' ? '请选择开仓时间或平仓时间' : '请选择统计日期')
      return false
    },
    fetchList() {
      if (!this.valid()) return
      this.loading = true
      api.list(this.kind, this.query()).then((res) => {
        if (!res || res.code !== 0) throw new Error((res && res.msg) || '查询失败')
        const d = res.data || {}; this.rows = d.items || []; this.total = Number(d.total || 0)
      }).catch((e) => { this.rows = []; this.total = 0; this.$message.error(e.message || '查询失败') }).finally(() => { this.loading = false })
    },
    search() { this.pagination.page = 1; this.fetchAll() },
    reset() { this.filters = createFilters(); this.pagination = { page: 1, size: 10 }; this.fetchAll() },
    pageChanged(v) { this.pagination = v; this.fetchList() },
    download(prefix) {
      if (!this.valid() || this.exportLoading) return
      this.exportLoading = true
      api.exportExcel(this.kind, this.query(false)).then((res) => {
        const blob = res instanceof Blob ? res : new Blob([res]); const url = URL.createObjectURL(blob); const a = document.createElement('a')
        a.href = url; a.download = `${prefix}${moment().format('YYYYMMDD')}001.xlsx`; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url)
      }).catch(() => this.$message.error('导出失败')).finally(() => { this.exportLoading = false })
    },
  },
}
